import { render, staticRenderFns } from "./ApprovalPartCard.vue?vue&type=template&id=681ca22f&scoped=true"
import script from "./ApprovalPartCard.vue?vue&type=script&lang=js"
export * from "./ApprovalPartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ca22f",
  null
  
)

export default component.exports